import React from 'react'

import './loading.scss'



export default function Loading() {



    return (
        <div className='loading'>
            <h3>...Loading</h3>
            <p>Please allow up to a minute while we reach the server</p>
        </div>
    )
}
